import { Box, IconicButton } from "@nulogy/components";
import DaysSelector from "components/common/DaysSelector";
import { GridBoxPlannedBreaks, StyledInput, StyledTimePicker } from "components/common/EditableListStyledComponents";
import FieldRow from "components/common/FieldRow";
import LinesSelector from "components/pages/plannedBreaks/LinesSelector";
import React from "react";

export default function EditablePlannedBreakRow({ testId, dirty, onCancel }) {
  return (
    <FieldRow data-testid={testId} marginBottom="0">
      <GridBoxPlannedBreaks>
        <StyledInput field="name" placeholder="Name" />
        <LinesSelector />
        <DaysSelector />
        <Box data-testid="start-time">
          <StyledTimePicker className="spec-planned-break-start-time" field="startTime" placeholder="Start Time" />
        </Box>
        <Box data-testid="end-time">
          <StyledTimePicker className="spec-planned-break-end-time" field="endTime" placeholder="End Time" />
        </Box>

        <Box paddingTop="x1">
          <IconicButton disabled={!dirty} icon="check" type="submit">
            Save
          </IconicButton>
        </Box>
        <Box paddingTop="x1">
          <IconicButton icon="close" onClick={onCancel} type="button">
            Cancel
          </IconicButton>
        </Box>
      </GridBoxPlannedBreaks>
    </FieldRow>
  );
}
